import { render, staticRenderFns } from "./UpdateSysMemberCoupon.vue?vue&type=template&id=954cfebc&scoped=true"
import script from "./UpdateSysMemberCoupon.vue?vue&type=script&lang=js"
export * from "./UpdateSysMemberCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954cfebc",
  null
  
)

export default component.exports